module.exports = __webpack_public_path__ + "media/images/Just-Wick-unlit-zoomed-47d7d211fd4c772949445cf66320f3e8.png";